"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpeningSuggestionSvgForm = void 0;
const yup = __importStar(require("yup"));
exports.OpeningSuggestionSvgForm = {
    initialValues: {},
    inputs: [
        {
            type: "file",
            id: "file",
            name: "Project",
            validation: yup.string().required(),
        },
        {
            type: "opening_suggestion",
            id: "suggestion",
            name: "Suggestion",
            validation: yup.string().required(),
        },
        {
            type: "number",
            id: "width",
            name: "Width",
            validation: yup.number(),
        },
        {
            type: "number",
            id: "height",
            name: "Height",
            validation: yup.number(),
        },
        {
            type: "number",
            id: "maxWidth",
            name: "Max Width",
            validation: yup.number(),
        },
        {
            type: "number",
            id: "maxHeight",
            name: "Max Height",
            validation: yup.number(),
        },
        {
            type: "string",
            id: "backgroundColor",
            name: "Background Color",
            validation: yup.string(),
        },
    ],
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiT3BlbmluZ1N1Z2dlc3Rpb25TdmdGb3JtLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvc2FuZGJveC9pbnB1dHMvZm9ybXMvT3BlbmluZ1N1Z2dlc3Rpb25TdmdGb3JtLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQUFBLHlDQUEyQjtBQUdkLFFBQUEsd0JBQXdCLEdBQW1CO0lBQ3RELGFBQWEsRUFBRSxFQUFFO0lBQ2pCLE1BQU0sRUFBRTtRQUNOO1lBQ0UsSUFBSSxFQUFFLE1BQU07WUFDWixFQUFFLEVBQUUsTUFBTTtZQUNWLElBQUksRUFBRSxTQUFTO1lBQ2YsVUFBVSxFQUFFLEdBQUcsQ0FBQyxNQUFNLEVBQUUsQ0FBQyxRQUFRLEVBQUU7U0FDcEM7UUFDRDtZQUNFLElBQUksRUFBRSxvQkFBb0I7WUFDMUIsRUFBRSxFQUFFLFlBQVk7WUFDaEIsSUFBSSxFQUFFLFlBQVk7WUFDbEIsVUFBVSxFQUFFLEdBQUcsQ0FBQyxNQUFNLEVBQUUsQ0FBQyxRQUFRLEVBQUU7U0FDcEM7UUFDRDtZQUNFLElBQUksRUFBRSxRQUFRO1lBQ2QsRUFBRSxFQUFFLE9BQU87WUFDWCxJQUFJLEVBQUUsT0FBTztZQUNiLFVBQVUsRUFBRSxHQUFHLENBQUMsTUFBTSxFQUFFO1NBQ3pCO1FBQ0Q7WUFDRSxJQUFJLEVBQUUsUUFBUTtZQUNkLEVBQUUsRUFBRSxRQUFRO1lBQ1osSUFBSSxFQUFFLFFBQVE7WUFDZCxVQUFVLEVBQUUsR0FBRyxDQUFDLE1BQU0sRUFBRTtTQUN6QjtRQUNEO1lBQ0UsSUFBSSxFQUFFLFFBQVE7WUFDZCxFQUFFLEVBQUUsVUFBVTtZQUNkLElBQUksRUFBRSxXQUFXO1lBQ2pCLFVBQVUsRUFBRSxHQUFHLENBQUMsTUFBTSxFQUFFO1NBQ3pCO1FBQ0Q7WUFDRSxJQUFJLEVBQUUsUUFBUTtZQUNkLEVBQUUsRUFBRSxXQUFXO1lBQ2YsSUFBSSxFQUFFLFlBQVk7WUFDbEIsVUFBVSxFQUFFLEdBQUcsQ0FBQyxNQUFNLEVBQUU7U0FDekI7UUFDRDtZQUNFLElBQUksRUFBRSxRQUFRO1lBQ2QsRUFBRSxFQUFFLGlCQUFpQjtZQUNyQixJQUFJLEVBQUUsa0JBQWtCO1lBQ3hCLFVBQVUsRUFBRSxHQUFHLENBQUMsTUFBTSxFQUFFO1NBQ3pCO0tBQ0Y7Q0FDRixDQUFDIn0=